// 优惠券状态
// 1: '未领取',2: '未使用',3: '可再次领取',4: '已使用',5: '已过期'
export const couponStatus = {
  1: '立即领取',
  2: '去使用',
  3: '立即领取',
  4: '已使用',
  5: '已过期'
};
